<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>
           
            <CommunitiesComp />

        </v-main>
    </v-app>
</template>
<script>
import Auth from '@/services/auth.service.js'
import CommunitiesComp from '@/components/admin/communities/CommunitiesComp.vue'

export default {
    components: {
        CommunitiesComp,
    },
    data() {
        return {
        };
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        document.title = 'קהילות | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
    },
}
</script>
<style>
</style>